// src/enums.ts
var NodeEnv = /* @__PURE__ */ ((NodeEnv2) => {
  NodeEnv2["Development"] = "development";
  NodeEnv2["Production"] = "production";
  NodeEnv2["Test"] = "test";
  return NodeEnv2;
})(NodeEnv || {});

export {
  NodeEnv
};
